import NewSalesCreditNote from "../../../../components/@documents/sales_credit_notes/NewSalesCreditNote";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesCreditNoteNewPage() {

    return (
        <NewSalesCreditNote 
            routeType={routeTypes.admin}
        />
    )
}